<template>
    <div>
        <div id="updatesModal" class="modal" data-backdrop="static" data-keyboard="false">
            <div class="modal-contents">
                <div class="update-course">
                    <div class="modal-heading">
                        <h1 class="main-heading">Fill Details to Continue</h1>
                    </div>
                    <div class="update-cour">
                        <div class="row">
                            <div class="col-md-12">
                                <form id="update-fields" @submit.prevent="updateUserDetail($event)">
                                    <div class="disTable">
                                        <div class="form-group" id="college-search">
                                            <label class="ep-input-label">College Name</label>
                                            <input type="text" class="form-control dash-input" id="college-input"
                                                   placeholder="Enter College Name" v-html="cCollege"
                                                   @change="validateCollege($event)" @focus="rmID()"/>
                                            <ul class="college-list"></ul>
                                            <p v-html="cCollegeError" class="error-msg"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="department">Department</label>
                                            <input type="text" class="form-control dash-input field-req"
                                                   name="department"
                                                   id="department" placeholder="Enter Department" v-model="department">
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="course_name">Course Name</label>
                                            <select class="form-control field-req" id="course_name" v-model="course_id"
                                                    name="course_id" @change="setSections($event)">
                                                <option value="">Select Course</option>
                                                <option v-for="cl in courses" v-bind:value="cl.assigned_college_enc_id">
                                                    {{cl.course_name}}
                                                </option>
                                            </select>
                                            <!--<div v-html="cNameError" class="form-text text-muted"></div>-->
                                        </div>
                                        <div class="form-group" v-if="sections.length">
                                            <label class="ep-input-label" for="section">Select Section</label>
                                            <select class="form-control field-req" id="section" name="section_id">
                                                <option value="">Select Section</option>
                                                <option v-for="sc in sections" v-bind:value="sc.section_enc_id">
                                                    {{sc.section_name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="semester">Select Semester</label>
                                            <select class="form-control field-req" id="semester" name="semester"
                                                    v-model="semester">
                                                <option value="" selected>Select Semester</option>
                                                <option value="1">1st Semester</option>
                                                <option value="2">2nd Semester</option>
                                                <option value="3">3rd Semester</option>
                                                <option value="4">4th Semester</option>
                                                <option value="5">5th Semester</option>
                                                <option value="6">6th Semester</option>
                                                <option value="7">7th Semester</option>
                                                <option value="8">8th Semester</option>
                                                <option value="9">9th Semester</option>
                                                <option value="10">10th Semester</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="year">Select Year</label>
                                            <select class="form-control field-req" id="year" name="year" v-model="year">
                                                <option value="" selected>Select Year</option>
                                                <option value="1">1st Year</option>
                                                <option value="2">2nd Year</option>
                                                <option value="3">3rd Year</option>
                                                <option value="4">4th Year</option>
                                                <option value="5">5th Year</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="starting_year">Starting Year</label>
                                            <input type="number" class="form-control field-req" id="starting_year"
                                                   placeholder="Starting Year" name="starting_year" min="2000"
                                                   v-model="starting_year">
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="ending_year">Ending Year</label>
                                            <input type="number" class="form-control field-req" id="ending_year"
                                                   placeholder="Ending Year" name="ending_year" max="2050"
                                                   v-model="ending_year">
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label" for="university_roll">University Roll
                                                Number</label>
                                            <input type="text" class="form-control field-req" id="university_roll"
                                                   placeholder="University Roll Number" name="roll_number"
                                                   v-model="roll_number">
                                        </div>
                                        <div class="form-group">
                                            <div class="radios">
                                                <label>
                                                    <input id="jobCheck" type="checkbox" name="choice_preference[]"
                                                           v-on:change="showJob($event)" value="job_placement"/>
                                                    <span>Job Placement</span>
                                                </label>
                                                <label class="job-check">
                                                    <input id="internshipCheck" type="checkbox"
                                                           name="choice_preference[]"
                                                           v-on:change="showInten($event)"
                                                           value="internship_placement"/>
                                                    <span>Internship Placement</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group" id="job-duration">
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <label class="ep-input-label" for="ending_year">Select Course Ending
                                                        Date</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <select class="form-control" id="months" name="job_start_month"
                                                                v-model="job_start_month">
                                                            <option value="january" selected>January</option>
                                                            <option value="february">February</option>
                                                            <option value="march">March</option>
                                                            <option value="april">April</option>
                                                            <option value="may">May</option>
                                                            <option value="june">June</option>
                                                            <option value="july">July</option>
                                                            <option value="august">August</option>
                                                            <option value="september">September</option>
                                                            <option value="october">October</option>
                                                            <option value="november">November</option>
                                                            <option value="december">December</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <select class="form-control" name="job_year" v-model="job_year">
                                                            <option value="2019" selected>2019</option>
                                                            <option value="2020">2020</option>
                                                            <option value="2021">2021</option>
                                                            <option value="2022">2022</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group" id="in-duration">
                                            <div class="">
                                                <div class="col-md-12 col-sm-12">
                                                    <label class="ep-input-label" for="ending_year">Select Internship
                                                        Duration</label>
                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <select class="form-control" id="duration"
                                                                name="internship_duration"
                                                                v-model="internship_duration">
                                                            <option value="0">6 Weeks</option>
                                                            <option value="1">3 Months</option>
                                                            <option value="2">6 Months</option>
                                                            <option value="3">1 Year</option>
                                                        </select>
                                                    </div>

                                                </div>
                                                <div class="col-md-6 col-sm-6">
                                                    <div class="form-group">
                                                        <div class='input-group date' data-provide="datepicker"
                                                             id='datepicker'>
                                                            <input type='text' class="form-control"
                                                                   name="internship_start_date"
                                                                   v-model="internship_start_date"/>
                                                            <div class="input-group-addon">
                                                                <span class="glyphicon glyphicon-calendar"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="align-center">
                                            <div class="form-group">
                                                <button type="submit" class="add-course">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Autocomplete from '@trevoreyre/autocomplete-js';
    import toastr from '../../public/js/toastr.js';
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

    export default {
        data() {
            return {
                college: '',
                cCollege: '',
                cCollegeError: '',
                department: '',
                course_id: '',
                semester: '',
                year: '',
                starting_year: '',
                ending_year: '',
                roll_number: '',
                internship_start_date: '',
                internship_duration: '',
                job_start_month: '',
                job_year: '',
                valid: false,
                courses: [],
                sections: [],
            }
        },
        mounted() {
            if (!document.getElementById('my-datepicker')) {
                var scriptTag = document.createElement("script");
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
                scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js";
                scriptTag.id = "my-datepicker";
                document.getElementsByTagName('head')[0].appendChild(link);
                document.getElementsByTagName('head')[0].appendChild(scriptTag);
                setTimeout(function () {
                    $(function () {
                        $("#datepicker").datepicker({
                            autoclose: true,
                            todayHighlight: true
                        }).datepicker('update', new Date());
                    });
                }, 2000);
            }
            var t = this;
            var jobduration = document.getElementById('job-duration');
            var induration = document.getElementById('in-duration');
            document.getElementById('internshipCheck').checked = false;
            induration.style.display = "none";
            document.getElementById('jobCheck').checked = false;
            jobduration.style.display = "none";
            new Autocomplete('#college-search', {
                search: input => {
                    const domain = this.$store.getters.getDomain
                    const url = `${domain}api/v2/utilities/get-companies?search=${encodeURI(input)}`

                    return new Promise(resolve => {
                        if (input.length < 1) {
                            return resolve([])
                        }

                        fetch(url)
                            .then(response => response.json())
                            .then(data => {
                                resolve(data)
                            })
                    })
                },
                renderResult: (result, props) => `
                        <li ${props}>
                          <div class="ss-icon">
                          <img src="${result.organization_logo}" />
                          </div>
                          <div class="ss-description">
                            ${result.name}
                          </div>
                        </li>
                    `,
                getResultValue: result => result.name,
                onSubmit: result => {
                    var collegeElem = document.getElementById('college-input-main');
                    t.college = result['organization_enc_id'];
                    t.cCollege = result['name'];
                    t.courses = result['courses'];
                    // t.college_selected = result['organization_enc_id'];
                    // t.org_img = result['organization_logo'];
                }
            });


        },
        methods: {
            updateUserDetail() {
                var t = this;
                var url = t.$store.getters.getDomain;
                if (!t.validateForm()) {
                    return false;
                }
                showLoader();
                var x, y;
                x = document.getElementById("datepicker");
                y = x.getElementsByTagName("input");
                t.internship_start_date = y[0].value;

                var data = {
                    'user_enc_id': t.$store.getters.getUser['user_id'],
                    'college': t.college,
                    'department': t.department,
                    'course_id': t.course_id,
                    'semester': t.semester,
                    'year': t.year,
                    'starting_year': t.starting_year,
                    'ending_year': t.ending_year,
                    'roll_number': t.roll_number,
                    'internship_start_date': t.internship_start_date,
                    'internship_duration': t.internship_duration,
                    'job_start_month': t.job_start_month,
                    'job_year': t.job_year,
                };
                if(document.getElementById('section')){
                    data['section_id'] = document.getElementById('section').value;
                }
                axios.post(`${url}api/v2/auth/save-other-detail`, data, {
                    headers: requestHeaders()
                }).then(function (response) {
                    hideLoader();
                    if (response['data']['response']['status'] == 201) {
                        $('#updatesModal').modal('hide');
                        toastr.success('Details Updated Successfully', 'Success');
                        window.location.replace("/");
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                }).catch(function (error) {
                    hideLoader();
                });
            },
            validateForm: function () {
                var x, y, z, i, a = this;
                a.valid = true;
                x = document.getElementById("update-fields");
                y = x.querySelectorAll(".field-req");
                if (!a.cCollege) {
                    a.cCollegeError = 'This field is required.';
                    a.valid = false;
                } else {
                    a.cCollegeError = '';
                }
                if (!a.validateCollege()) {
                    a.valid = false;
                }
                for (i = 0; i < y.length; i++) {
                    if (y[i].value == "") {
                        y[i].className += " invalid";
                        a.valid = false;
                        if (y[i].nextSibling == null) {
                            var node = document.createElement("P");
                            node.classList = "error-msg";
                            var textnode = document.createTextNode("This field is Required.");
                            node.appendChild(textnode);
                            y[i].parentElement.appendChild(node);
                        }
                    } else {
                        y[i].classList.remove('invalid');
                        if (y[i].nextSibling) {
                            y[i].nextSibling.remove();
                        }
                    }
                }
                return a.valid;
            },
            validateCollege() {
                var t = this;
                if (t.college == "") {
                    t.cCollegeError = 'Please select valid college.';
                    return false;
                } else {
                    t.cCollegeError = '';
                    return true;
                }
            },
            rmID() {
                this.college == ""
            },
            showJob: function (e) {
                if (e.target.checked) {
                    document.getElementById('job-duration').style.display = "inline-block";
                } else {
                    document.getElementById('job-duration').style.display = "none";
                }
            },
            showInten: function (e) {
                if (e.target.checked) {
                    document.getElementById('in-duration').style.display = "inline-block";
                } else {
                    document.getElementById('in-duration').style.display = "none";
                }
            },
            setSections(event) {
                var t = this;
                var element = event.currentTarget
                var val = element.value;
                for (var i = 0; i < t.courses.length; i++) {
                    if (t.courses[i].assigned_college_enc_id == val) {
                        if (t.courses[i].collegeSections.length) {
                            t.sections = t.courses[i].collegeSections;
                        } else {
                            t.sections = [];
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .modal-contents {
        /*overflow: hidden !important;*/
        position: relative;
        background-color: #fff;
    }

    .modal-heading {
        text-align: center;
        padding: 10px;
    }

    .update-cour {
        position: absolute;
        left: 50%;
        -webkit-transform: translate(-50%, 0%);
        transform: translate(-50%, 0%);
        width: 100%;
    }

    form {
        max-width: 700px;
        margin: 0 auto;
    }

    #update-fields > .disTable > .form-group {
        width: 44%;
        margin: 0px 2%;
        display: inline-block;
        height: 90px;
    }

    .radios {
        padding-top: 30px;
        float: left;
    }

    .add-course {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .add-course:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }

    .align-center {
        text-align: center;
    }

    .service-list {
        display: inline-block;
        min-width: 90px;
        text-align: center;
        margin: 0px 5px;
    }

    .service-list > label {
        width: 100%;
        display: inline-block;
        background-color: rgba(255, 255, 255, .9);
        border: 2px solid rgba(139, 139, 139, .3);
        color: #333;
        border-radius: 4px;
        white-space: nowrap;
        margin: 3px 0px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        transition: all .2s;
    }

    .service-list > label {
        padding: 8px 5px;
        cursor: pointer;
    }

    .service-list > input[type='radio']:checked + label, .service-list > label:hover {
        border: 2px solid #00a0e3;
        background-color: #00a0e3;
        color: #fff;
        transition: all .2s;
    }

    .service-list > input {
        position: absolute;
        opacity: 0;
    }

    .service-list > input[type='radio']:focus + label {
        border: 2px solid #00a0e3;
    }
</style>